import { now } from "moment";

const optionsUsd = { style: 'currency', currency: 'USD', numberingSystem: "latn" };
const numberFormatUsd = new Intl.NumberFormat('en-US', optionsUsd);
const roundToTwo = (value: number, decimals = 2): number => (Number(Math.round(parseFloat(value.toString() + 'e' + decimals)) + 'e-' + decimals));

const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '13px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '13px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            boxShadow: 0,
            "text-align-last": "left",
            // "outline-style": state.isFocused ? "none" : "",
            //"border-left": state.isFocused ? "2px solid #008964" : "2px solid #e4e4e4",
            // "border-bottom": state.isFocused ? "1px solid #bae6da" : "",
            // "border-top": state.isFocused ? "1px solid #bae6da" : "",
            // "border-right": state.isFocused ? "1px solid #bae6da" : "",
            '&:hover': {
                border: '0 !important',
                "outline-style": "none !important",
                "border-left": "2px solid #008964 !important",
                "border-bottom": "1px solid #bae6da !important",
                "border-top": "1px solid #bae6da !important",
                "border-right": "1px solid #bae6da !important",
            },
            selectProps: {
                backgroundColor: "#008964",
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const propMsg = {
    txtMsg: 'Cargando...',
    active: false
} as IModalProps

const propLoading = {
    txtMsg: 'Cargando...',
    active: false
} as IModalProps

const GetVehicleValueDepre = (data: IAutoNI) => {
    let mount: number = 0;
    if (data.planConfig.aplicaDepreciacion) {
        if (data.planConfig.depreciaciones.length > 0) {
            const dateNow = new Date();
            const yearDepreciation: number = dateNow.getFullYear() - parseInt(data.vehicleYear);
            const depreciation = data.planConfig.depreciaciones.find(x => x.id === yearDepreciation);
            if (depreciation !== undefined)
                mount = roundToTwo(parseFloat(data.vehicleValueStr) * depreciation.porcentaje);
        }
    }
    return mount.toString();
}

const GetDataRates = (data: IAutoNI) => {


    const obj: Record<string, any> = {
        itipopol: 'I',
        VigenciaPol: 'A',
        valn: data.vehicleValue,
        mode: data.vehicleModel,
        marca: data.vehicleBrand,
        marc: data.vehicleBrand,
        anio: data.vehicleYear,
        usoo: data.vehicleUse,
        suma: data.sumAssured,
        cate: data.datasheet.auCategoria,
        nasiento: data.datasheet.auNumPasajeros,
        tipo: data.datasheet.auTipo,
        valnreal: data.vehicleValue,
        codigo1: 0, //revisar 
        auNuevo: data.vehicleStatus
    };

    let coverageIdsStr = "[";
    data.coveragesPlan.coverages.map((x: ICoverages) => {
        if (x.obligatoria) {
            obj[`Cob${x.idCob}`] = 1;
            coverageIdsStr = coverageIdsStr + `${x.idCob},`;
        }
    });
    coverageIdsStr = coverageIdsStr.substring(0, coverageIdsStr.length - 1) + "]";
    obj["coverageIds"] = coverageIdsStr;


    return obj
}


const GetResumen = (data: IAutoNI) => {


    let coveragesDetail: Array<IRatesTable> = [];
    let bonusTax: number = 0;

    data.rates['rates'].map((rate: IRates) => {
        let nameCover = data.coveragesPlan.coverages.find(x => x.idCob === rate.idCob);
        if (nameCover !== undefined) {
            let insuredMount = parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1);
            let det: IRatesTable = {
                name: nameCover.nombre,
                insured: numberFormatUsd.format(insuredMount),
                sa: rate.sa,
                value: numberFormatUsd.format(parseFloat(rate.sa))
            };
            coveragesDetail.push(det);

            if (nameCover.bImpuesto1)
                bonusTax = bonusTax + parseFloat(rate.prima);
        }
    });

    let financing: number = 0;

    let rightEmission: number = roundToTwo(bonusTax * (data.planConfig.porcentajeGasto / 100));
    if (rightEmission < data.planConfig.gastoMontoMinimo)
        rightEmission = data.planConfig.gastoMontoMinimo;
    if (rightEmission > data.planConfig.gastoMontoMaximo)
        rightEmission = data.planConfig.gastoMontoMaximo;

    let porDesc = data.planConfig.descuentoMaximo ?? 0;
    let taxFinancing = data.planConfig.intereses ?? undefined;


    let bonus = roundToTwo(data.rates['rates'].map((x: any) => ({ ...x, prima: roundToTwo(x.prima) + roundToTwo((x.prima * x.pRecargo) / 100) })).sum('prima'));
    let desc = roundToTwo(data.rates['rates'].map((x: any) => ({ ...x, desc: roundToTwo((x.prima * x.pRecargo) / 100) * (porDesc * 100) })).sum('desc'));
    let bonusDE = bonusTax;
    let bonus2 = roundToTwo(bonus - desc);

    if (taxFinancing !== undefined) {
        let taxP = taxFinancing.find((x: any) => x.frecuenciaPago === parseInt(data.paymentFrequency));
        if (taxP !== undefined)
            financing = roundToTwo((bonus * (parseFloat(taxP.porcentajeInteres) / 100)));
    }

    let tax = roundToTwo((bonusTax + rightEmission) * (data.planConfig.impuestos.interes / 100));
    let total = roundToTwo(bonus2 + tax + financing + rightEmission);

    let bonusAnnual = roundToTwo(total / findInteresByFrecuency(1));
    let bonusSemester = roundToTwo(total / findInteresByFrecuency(2));
    let bonusQuarterly = roundToTwo(total / findInteresByFrecuency(4));
    let bonusMonthly = roundToTwo(total / findInteresByFrecuency(12));

    let result: IRatesResumen = {
        coveragesDetail: coveragesDetail,
        bonus: bonus,
        desc: desc,
        bonus2: bonus2,
        tax: tax,
        financing: financing,
        total: total,
        bonusDE: bonusDE,
        rightEmission: rightEmission,


        bonusStr: numberFormatUsd.format(bonus),
        descStr: numberFormatUsd.format(desc),
        bonus2Str: numberFormatUsd.format(bonus2),
        taxStr: numberFormatUsd.format(tax),
        financingStr: numberFormatUsd.format(financing),
        totalStr: numberFormatUsd.format(total),

        bonusAnnual: numberFormatUsd.format(bonusAnnual),
        bonusSemester: numberFormatUsd.format(bonusSemester),
        bonusQuarterly: numberFormatUsd.format(bonusQuarterly),
        bonusMonthly: numberFormatUsd.format(bonusMonthly),
        bonusFrecuencia: 0,
        rightEmissionsStr: numberFormatUsd.format(rightEmission),
    }


    return result;

}

const BuilData = (data: IAutoNI, source: string | null) => {

    let lstBeneficiary: any = [];
    let lstAnswers: any = [];
    let polCobs: any = [];
    let polCobsDesc: any = [];

    let policy: any = {
        Plan: data.idPlan,
        SA: data.sumAssured,
        Prima: data.summary.bonus,
        Descuento: data.summary.desc,
        PrimaDE: data.summary.bonus,
        PrimaNeta: data.summary.bonus2,
        PrimaExonerada: 0,
        Impuesto: data.summary.tax,
        Total: data.summary.total,
        Frecuencia: data.paymentFrequency,
        Cuotas: data.paymentFrequency,
        Estado: 0,
        mInteres: data.summary.financing,
        DerechoEmision: data.summary.rightEmission,
        Source: source
    };


    let auMarcaDesc = data.catVehicleBrand.find((x: any) => x.value === data.vehicleBrand.trim());
    let auModeloDesc = data.catVehicleModel.find((x: any) => x.value === data.vehicleModel.trim());

    let au = {
        SA: data.sumAssured,
        auMarca: auMarcaDesc?.text,
        auModelo: auModeloDesc?.text,
        auAnio: data.vehicleYear,
        auCategoria: data.rates.auCategoria,
        auValorNuevo: data.sumAssured,
        auNumPasajeros: data.rates.auNumPasajeros,
        auUso: data.rates.usoo,
        auChasis: data.vehicleChassis,
        auVin: data.vehicleChassis,
        auGPS: false,
        auNuevo: data.vehicleStatus === "1", true: false,
    };

    let insured = {
        TipoId: data.identificationType,
        NumId: data.identification,
        Nombre: `${data.firstName1} ${data.firstName2}`,
        Apellido: `${data.lastName1} ${data.lastName2}`,
        TelefonoCelular: data.phoneNumber,
        Email: data.mail,
        EstadoCivil: data.civilStatus
    }

    data.rates['rates'].map((rate: IRates) => {

        let nameCover = data.coveragesPlan.coverages.find(x => x.idCob === rate.idCob);
        let tempCover: any = {};

        if (nameCover !== undefined) {

            tempCover['Nombre'] = nameCover.nombre;
            tempCover['orden'] = nameCover.orden;

            tempCover["IdCob"] = rate.idCob;
            tempCover["SA"] = rate.sa;
            tempCover["Prima"] = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
            tempCover["ptasa"] = rate.pTasa;
            tempCover["pdescuento"] = 0;
            tempCover["mdescuento"] = 0;
            tempCover["mprimabruta"] = rate.prima;
            tempCover["PrimaDE"] = rate.prima;
            tempCover["Etiqueta"] = 0;
            tempCover["bDescuentoManual"] = 0;
            tempCover["PrimaGravada"] = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1))
            tempCover["COA"] = rate.coa
            tempCover["Deducible"] = rate.deducible

            polCobs.push(tempCover);
        }
    });


    policy['Respuesta'] = lstAnswers;
    policy['Beneficiarios'] = lstBeneficiary;
    policy['PolCobs'] = polCobs; //polCobsDesc
    policy['PolCobsDesc'] = polCobsDesc;
    policy['Au'] = au;
    policy['Asegurado'] = insured;
    policy['FormaPagos'] = '';
    return policy;

}


const findInteresByFrecuency = (month: number) => {
    switch (month) {
        case 2: return 2;
        case 4: return 4;
        case 12: return 12;
        default: return 1;
    }
}

const BuildDataOportunity = (data: IAutoNI, src: string) => {
    let dataOportunity: INotificationOportunity = {
        TipoId: parseInt(data.identificationType),
        Identificacion: data.identification,
        Nombre: `${data.firstName1} ${data.firstName2}`,
        Apellido: `${data.lastName1} ${data.lastName2}`,
        Email: data.mail,
        Celular: data.phoneNumber,
        Source: src ?? '',
        Nombres: `${data.firstName1} ${data.firstName2}`
    }

    return dataOportunity;
}

const GetDataNotification = (data: IAutoNI, type: number) => {
    let dataNotification ={ 
        idPoliza: data.policyNumber,
        idOportunidad: '',
        nombre: `${data.firstName1} ${data.firstName2} ${data.lastName1} ${data.lastName2}`,
        correo:data.mail,
        celular: data.phoneNumber,
        tipoNotificacion: type,
        adjuntos: []
    }
    return dataNotification;
}

export {
    customStyles,
    propMsg,
    propLoading,
    GetDataRates,
    GetResumen,
    BuilData,
    BuildDataOportunity,
    GetVehicleValueDepre,
    GetDataNotification
};
